import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteTicketActions'
import * as api from '../../api/job/tickets'

function* jobTicketRefresh(action) {
  try {
    const payload = yield call(api.getTickets, action.jobId)
    yield put({ type: constants.JOB_TICKET_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_TICKET_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobTicket() {
  yield takeLatest(constants.JOB_TICKET_REFRESH.ACTION, jobTicketRefresh)
}

function* sagaCreateJobTicket(action) {
  try {
    yield call(api.createTicket, action.content)
    yield put({ type: constants.JOB_TICKET_CREATE.SUCCESS })
    yield call(jobTicketRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_TICKET_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobTicket() {
  yield takeLatest(constants.JOB_TICKET_CREATE.ACTION, sagaCreateJobTicket)
}

function* sagaUpdateJobTicket(action) {
  try {
    const payload = {
      ticketId: action.ticketId,
      content: action.content
    }
    yield call(api.updateTicket, payload)
    yield put({ type: constants.JOB_TICKET_UPDATE.SUCCESS })
    yield call(jobTicketRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_TICKET_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobTicket() {
  yield takeLatest(constants.JOB_TICKET_UPDATE.ACTION, sagaUpdateJobTicket)
}

function* sagaDeleteJobTicket(action) {
  try {
    yield call(api.deleteTicket, { ticketId: action.ticketId })
    yield put({ type: constants.JOB_TICKET_DELETE.SUCCESS })
    yield call(jobTicketRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_TICKET_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobTicket() {
  yield takeLatest(constants.JOB_TICKET_DELETE.ACTION, sagaDeleteJobTicket)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      ticketId: action.ticketId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_TICKET_ATTACHMENT.SUCCESS })
    yield call(getAttachments, { ticketId: action.ticketId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_TICKET_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_TICKET_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.ticketId)
    yield put({ type: constants.GET_TICKET_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_TICKET_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_TICKET_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_TICKET_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { ticketId: action.ticketId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_TICKET_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_TICKET_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      ticketId: action.ticketId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_TICKET_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { ticketId: action.ticketId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_TICKET_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_TICKET_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobTicket),

    fork(watchCreateJobTicket),
    fork(watchUpdateJobTicket),
    fork(watchDeleteJobTicket),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteTicketSaga.js